import React, { useState } from "react";
import { get } from "lodash";
import { Link } from "@quintype/components";

import "./secvideoselector.m.css";
import DownArrow from "../../atoms/other-icons/DownArrow";
import Arrow from "../../atoms/other-icons/Arrow";

const SecVideoSelector = ({ selectItem, VideosCollections }) => {
  const [selectedItemIndex, setItemIndex] = useState(0);
  const { slug } = VideosCollections[selectedItemIndex];
  const customSeeMore = get(VideosCollections, [`${selectedItemIndex}`, "associated-metadata", "see more"], "");
  const [showOptions, setShowOptions] = useState(false);
  const [dropdownTitle, setDropdownTitle] = useState("");
  const [checked, setChecked] = useState(
    `${VideosCollections[0].name || VideosCollections[0].metadata?.["display-name"]}`
  );

  const dropdownHandler = () => {
    setShowOptions(!showOptions);
  };
  const checkChangeHandler = (val, idx) => {
    setDropdownTitle(val);
    setChecked(val);
    selectItem(val, idx);
  };

  return (
    <div styleName="choose-item-container">
      <div styleName="choose-item-wrapper" className="hide-mobile">
        {VideosCollections.slice(0, 5).map((item, i) => {
          return (
            <div
              key={i}
              styleName={selectedItemIndex === i ? "choose-item choose-item_active" : "choose-item"}
              onClick={() => {
                setItemIndex(i);
                selectItem(item.name, i);
              }}
            >
              <p>{item?.metadata?.["display-name"] || item?.name}</p>
            </div>
          );
        })}
      </div>
      <div>
        <div onClick={dropdownHandler} styleName="dd" className="hide-desktop">
          <button styleName="dd-btn">
            {dropdownTitle || VideosCollections[0].metadata?.["display-name"] || VideosCollections[0].name}
            <DownArrow color="black" height="14px" width="14px" />
          </button>
          {showOptions && (
            <div styleName="dropdown-section-mobile">
              {VideosCollections.slice(0, 5).map((option, idx) => {
                return (
                  <div
                    key={idx}
                    styleName={`dropdown-option ${
                      checked === option?.metadata?.["display-name"] || checked === option?.name ? "changeBg" : ""
                    }`}
                  >
                    <label
                      htmlFor={`radio_${idx}`}
                      onClick={() => checkChangeHandler(option?.metadata?.["display-name"] || option?.name, idx)}
                    >
                      <input
                        id={`radio_${idx}`}
                        type="radio"
                        value={option?.metadata?.["display-name"] || option?.name}
                        checked={checked === option?.metadata?.["display-name"] || checked === option?.name}
                        onChange={(e) => checkChangeHandler(e.target.value, idx)}
                      />
                      {option?.metadata?.["display-name"] || option?.name}
                    </label>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <Link href={customSeeMore || slug} styleName="seemore-link" className="headline-link">
        <div styleName="seemore">
          <span styleName="more">ಇನ್ನಷ್ಟು </span>
          <span styleName="right-arrow">
            <Arrow color="#b82831" width="16px" height="16px" />
          </span>
        </div>
      </Link>
    </div>
  );
};

export default SecVideoSelector;
